/* @flow */
import MessageDelivery from 'entities/MessageDelivery';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';

export default class GroupMessageDelivery extends MessageDelivery {
  static createFromGroupMessage(groupMessage) {
    return new GroupMessageDelivery({
      message_type: 'broadcast',
      message_uuid: groupMessage.getUuid(),
      read_summary: new MessageDeliverySummary(groupMessage.getReadSummary()),
      stream_uuid: null,
    });
  }
}



// WEBPACK FOOTER //
// ./src/entities/GroupMessageDelivery.js